import { Outlet } from "react-router-dom";
import { BrandNav, BrandFooter } from "@satyrsmc/shared/components";
import { MemberNavLinks } from "./MemberNavLinks";
import { UserAvatar } from "./UserAvatar";
import { ENV } from "@/env";
import { useAuth } from "@/state/AuthContext";

export function MembersLayout() {
  const { isAuthenticated } = useAuth();
  return (
    <div className="min-h-screen flex flex-col text-white bg-satyrs-dark">
      <BrandNav
        logoHref={ENV.PUBLIC_URL || "https://satyrsmc.org"}
        links={(close) => <MemberNavLinks onClose={close} />}
        trailing={<UserAvatar />}
      />
      <main className="flex-1">
        <Outlet />
      </main>
      <BrandFooter isAuthenticated={isAuthenticated} />
    </div>
  );
}
